// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCreateWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyCreateWebApiHandler_create,
  RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding,
  RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingType,
  PropertyType,
  UserPropertyCreateResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  customerId?: string;
  fullAddress: string;
  includeWebAnalytics?: boolean;
  listingType: ListingType;
  numUnits?: number;
  propertyType: PropertyType;
  unitNumber?: string;
}
interface CreateForSelfServeOnboardingParams {
  accountZrnNumber: string;
  fullAddress: string;
  listingType: ListingType;
  propertyType: PropertyType;
}

export interface RentalManagerUserPropertyCreateWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyCreateWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyCreateWebApiHandler_create_Args
>;

/**
 * Create a property for the user
 */
export const useRentalManagerUserPropertyCreateWebApiHandler_create = (
  options: Omit<RentalManagerUserPropertyCreateWebApiHandler_create_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCreateWebApiHandler_create_Args) =>
      RentalManagerUserPropertyCreateWebApiHandler_create(args.getParams),
  });
};

export type RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Options = UseQueryOptions<
  string,
  unknown,
  string,
  readonly [string, CreateForSelfServeOnboardingParams]
>;

const RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_GetKey = (
  getParams: CreateForSelfServeOnboardingParams,
) => [RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Path, getParams] as const;

export const RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_queryOptions = (
  getParams: CreateForSelfServeOnboardingParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding(getParams),
  }) as const satisfies QueryOptions;

/**
 * Create a property for the user for self serve onboarding
 */
export const useRentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding = (
  getParams: CreateForSelfServeOnboardingParams,
  options: Omit<
    RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding.getKey =
  RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_GetKey;
